import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { px as _px, withVars as _withVars, cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("skeleton__color-24faef", {
  minHeight: "12px",
  width: "100%",
  animation: "var(--static-styles-1v71nxnl_animation)",
  borderRadius: "var(--static-styles-1yypfhcq_borderRadius)"
});
import React from 'react';
import Color, { colors } from '../colors';
import { borderRadius } from '../tokens';

/*
* Will conditionally render a skeleton if no children exist inside.
* */

interface SkeletonProps extends Omit<HtmlPropsNoRef<HTMLDivElement>, 'as'> {
  isButton?: boolean;
  backgroundColor?: keyof typeof colors;
}
const Skeleton = ({
  children,
  isButton,
  backgroundColor,
  color,
  ...props
}: SkeletonProps): JSX.Element => {
  const pulseKeyframes = "static-styles-skeleton-kf-106wev1m";
  const hasChildren = React.Children.toArray(children).filter(x => !!x).length > 0;
  return <div>
            {!hasChildren && <Color {..._mergeComponentProps({
      backgroundColor: backgroundColor || 'grey300',
      role: "region",
      "aria-busy": "true",
      css: _withVars(_staticStyles, {
        "--static-styles-1v71nxnl_animation": _px(`${pulseKeyframes} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite`),
        "--static-styles-1yypfhcq_borderRadius": _px(isButton ? borderRadius.full : borderRadius.small)
      })
    }, props, {
      dangerouslySetInnerHTML: {
        __html: '&nbsp;'
      }
    })} />}
            {hasChildren && children}
        </div>;
};
export default Skeleton;
export * from './shimmer.styles';
export { ShimmerSlot } from './shimmer-slot';
export type { ShimmerSlotProps } from './shimmer-slot';
export { usePreloadReady, resolveContentStackPreloadSrc } from './use-preload-ready';
export type { PreloadImageInput, UsePreloadReadyOptions, UsePreloadReadyResult } from './use-preload-ready';